import { render } from "./SkinAnalysisResultView.vue?vue&type=template&id=2c363c4b&scoped=true"
import script from "./SkinAnalysisResultView.vue?vue&type=script&lang=js"
export * from "./SkinAnalysisResultView.vue?vue&type=script&lang=js"

import "./SkinAnalysisResultView.vue?vue&type=style&index=0&id=2c363c4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c363c4b"]])

export default __exports__